module.exports = __webpack_public_path__ + "media/application/images/ca-logo-993908fcddba88383e0464b54faa34c8.png";